// Phase 4a — knowledge-graph ops module. Consumers compose with
// `createOpTable([...builtins, ...knowledgeGraphOps])` to register the
// op set in an engine table. Internal helpers (`partitionFilter`,
// `translatePredicateToCdf`) are imported directly from their source
// files; this module only exposes the composable op array to keep the
// chat-side fetcher's surface minimal.

import { qkg } from './qkg.ts';

/**
 * All ops contributed by the knowledge-graph module. Today this is just
 * `qkg`; future view-aware ops (`from-view`, etc.) add to this list.
 */
export const knowledgeGraphOps = [qkg] as const;
